// extracted by mini-css-extract-plugin
module.exports = {"bar":"bar_bar__15K-9"};